import React from "react";
import "./App.css";
import Home from "./Components/Home";
import Navbar from "./Components/Navbar";
import Ultra from "./Components/Ultra";
import Ultraplus from "./Components/Ultraplus";
import Ultimate from "./Components/Ultimate";
import Platinum from "./Components/Platinum";
import Glossblack from "./Components/Glossblack";
import Matte from "./Components/Matte";
import Windowfilm from "./Components/Windowfilm";
import Installers from "./Components/Installers";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Warranty from "./Components/Warranty";
import AdminLogin from "./Components/AdminLogin";
import WarrantyLookup from "./Components/WarrantyLookup";
import PrivateRoute from "./PrivateRoute";

function App() {
  return (
    <>
      <Router>
        <div>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ultra" element={<Ultra />} />
            <Route path="/ultraplus" element={<Ultraplus />} />
            <Route path="/ultimate" element={<Ultimate />} />
            <Route path="/platinum" element={<Platinum />} />
            <Route path="/glossblack" element={<Glossblack />} />
            <Route path="/matte" element={<Matte />} />
            <Route path="/windowfilm" element={<Windowfilm />} />
            <Route path="/installers" element={<Installers />} />
            <Route path="/admin" element={<AdminLogin />} />

            <Route path="/search" element={<WarrantyLookup />} />
            <Route
              path="/warranty"
              element={
                <PrivateRoute>
                  <Warranty />
                </PrivateRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </>
  );
}
export default App;
